'use strict';
import React, { PureComponent } from 'react';


class ModelosSeleccionados extends PureComponent {
    constructor(props) {
        super(props);

        this.guardarQuitarModeloSeleccionado = this.guardarQuitarModeloSeleccionado.bind(this);
        this.ocultarBotonVerMas = this.ocultarBotonVerMas.bind(this);
    }

    guardarQuitarModeloSeleccionado(modelo, adicionarModelo) {
        this.props.guardarQuitarModeloSeleccionado(this.props.seccionInput, modelo, adicionarModelo);
    }

    ocultarBotonVerMas() {
        this.props.ocultarBotonVerMas();
    }

    render() {
        const {
            modelosSeleccionados, 
            mostrarVerMas
        } = this.props;

        let arrayModelosSeleccionados = [];

        let linkVerMas = <div className="ABMModelosModalContainer__linkVerMas"><span onClick={this.ocultarBotonVerMas}>Ver más...</span></div>

        modelosSeleccionados?.map(modelo => {
            let descripcionModelo = modelo.Codigo == "Todos" ? modelo.Codigo : modelo.Codigo + " - " + modelo.Descripcion;
            descripcionModelo = descripcionModelo.length > 16 ? descripcionModelo.substr(0, 15) + String.fromCharCode(8230) : descripcionModelo;

            arrayModelosSeleccionados.push(
                <div key={modelo.Codigo} className="btn-group ABMModelosModalContainer__botonModelo">
                    <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-left not-clickable ABMModelosReemplazar__botonModeloDescripcion">{descripcionModelo}</button>
                    <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-right" onClick={() => this.guardarQuitarModeloSeleccionado(modelo.Codigo, false)} >
                        <span className="ti-close span-closable color-white" title="Quitar Modelo"></span>
                    </button>
                </div>
            )
        });

        arrayModelosSeleccionados = arrayModelosSeleccionados.length > 9 && mostrarVerMas ?
                                        [...arrayModelosSeleccionados.slice(0,9), linkVerMas]
                                    : 
                                        arrayModelosSeleccionados;


        return (
            <div className="ABMModelosModalContainer__contenedorBotonModelo">
                {arrayModelosSeleccionados}
            </div>
        );
    }
}

export default ModelosSeleccionados;